import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../providers";
import { AdmPanelContainer } from "../../../../adm-panel/site/api/screens";
import { DashboardRequestResponse } from "../../../business/core";
import { DashboardControllerImpl } from "../../../business/impl/controllers";
import { DashboardFactoryImpl } from "../factories";

export const DashboardPage = () => {
  const { setCallbackLogin, handleLogout, userData } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(true);
  const [content, setContent] = useState<DashboardRequestResponse | null>(null);

  const controller = new DashboardControllerImpl();
  const factory = new DashboardFactoryImpl();

  const fetchData = async () => {
    try {
      const response = await controller.onLoad();
      setLoading(false);
      setContent(response);
    } catch (error) {
      switch (error) {
        case "401":
          setCallbackLogin(
            {
              goBack: true,
              origin: '/adm/dashboard',
            }
          );
          handleLogout();
          navigate('/auth');
          break;
        case "403":
          navigate('/subscription');
          break
        default:
          localStorage.setItem('global-toast', JSON.stringify({ type: 'danger', message: 'Erro na requisição' }));
          window.location.reload();
          break;
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  return isLoading ? <Spinner animation="border" variant="primary" /> : <AdmPanelContainer children={factory.create(content, userData.subscriber)} />;
};
